import React, { useMemo } from "react";
import { Logo } from "../../Logo";
import { SocialMedia } from "./SocialMedia";
import { LiveChatCTA } from "./LiveChatCTA";
export const SocialBarLogoLiveChat = ({ logo, socialMedia, liveChatCTA, }) => {
    const handleComponentClassName = useMemo(() => {
        if (!socialMedia || socialMedia.length === 0) {
            return "social-bar-with-no-media";
        }
        return "social-bar-logo-livechat__livechat-cta";
    }, [socialMedia]);
    return (React.createElement("div", { className: "social-bar-logo-livechat" },
        React.createElement("div", { className: "social-bar-logo-livechat__logo" },
            React.createElement(Logo, { imageUrl: logo.logoImageUrl, alt: logo.logoImageAlt, logoHref: logo.logoHref })),
        liveChatCTA?.liveChatText && (React.createElement("div", { className: handleComponentClassName },
            React.createElement(LiveChatCTA, { liveChatText: liveChatCTA?.liveChatText }))),
        (Array.isArray(socialMedia) && socialMedia.length > 0) && React.createElement(SocialMedia, { socialMedia: socialMedia })));
};
